/* The studio's own motion work, ready to nest inside a project's portal.
 *
 * Films live either in this worker's own assets (`/films/*.html` — self-contained
 * single files, no external requests) or on a worker the studio controls. Both
 * are same-studio origins, so they frame cleanly and don't rot the way a shared
 * link does. Adding one to a project is a one-click job, not a URL to retype. */

export interface FilmEntry {
  key: string;
  title: string;
  subtitle: string;
  url: string;
  /** The client this was made for — used to surface it on the right project. */
  forClient?: string;
  /** Words to match a project against, so the right film is offered first. */
  match?: RegExp;
  note: string;
  autoplay?: boolean;
}

export const FILM_LIBRARY: FilmEntry[] = [
  {
    key: "prems-intention",
    title: "Intention",
    subtitle: "The idea, before the building",
    /* Keep the .html: `vite dev` serves public/ verbatim and has no extensionless
       route, while Cloudflare Assets 307s the extension away in production. The
       iframe follows that redirect, so this one path works in both. */
    url: "/films/prems-intention.html",
    forClient: "Prems Electrical",
    match: /prems/i,
    note: "How the massing comes about — extrude, terrace to the sun, slide to the view, lift on pilotis. Watch it before the options.",
    autoplay: true,
  },
  {
    key: "prems-synthesis",
    title: "The Embrace, The Gathering, The Keystone",
    subtitle: "Three ways to build it — the full film",
    url: "https://prems-synthesis.renauto.workers.dev/",
    forClient: "Prems Electrical",
    match: /prems/i,
    note: "Thirty-four years, the site, and the three massing options in plan. Eleven chapters — it plays itself, or use ← and → to skip.",
    autoplay: true,
  },
];

/** Films worth offering on this project, best match first. */
export function filmsFor(project: { name?: string; client?: { name?: string; company?: string } }): FilmEntry[] {
  const hay = [project.name, project.client?.name, project.client?.company].filter(Boolean).join(" ");
  const hit = (f: FilmEntry) => !!f.match && f.match.test(hay);
  return [...FILM_LIBRARY].sort((a, b) => Number(hit(b)) - Number(hit(a)));
}

/** True when this library film is the one this project is actually about. */
export function isForProject(f: FilmEntry, project: { name?: string; client?: { name?: string; company?: string } }): boolean {
  const hay = [project.name, project.client?.name, project.client?.company].filter(Boolean).join(" ");
  return !!f.match && f.match.test(hay);
}
